import React from 'react';
import { History } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/Card';
import { formatMoney } from '../../utils/formatMoney';
import { YIKI_BET_TYPE_LABELS } from '../../utils/yikiUtils';

const STATUS_LABELS = {
  pending: { text: 'รอผล', className: 'text-amber-600 bg-amber-50' },
  won: { text: 'ถูกรางวัล', className: 'text-green-700 bg-green-50' },
  lost: { text: 'ไม่ถูก', className: 'text-gray-500 bg-gray-100' },
};

export function YikiBetHistory({ bets }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-base">
          <History className="h-5 w-5 text-brand-red" />
          ประวัติการแทง
        </CardTitle>
      </CardHeader>
      <CardContent>
        {bets.length === 0 ? (
          <p className="text-sm text-gray-500">ยังไม่มีประวัติการแทง</p>
        ) : (
          <ul className="max-h-64 space-y-2 overflow-y-auto">
            {bets.map((bet) => {
              const status = STATUS_LABELS[bet.status] || STATUS_LABELS.pending;
              return (
                <li
                  key={bet.id}
                  className="flex items-center justify-between rounded-lg border border-gray-100 bg-gray-50 px-3 py-2 text-sm"
                >
                  <div>
                    <span className="font-mono font-bold text-brand-red">
                      {bet.number}
                    </span>
                    <span className="mx-2 text-gray-300">|</span>
                    <span className="text-gray-600">
                      {YIKI_BET_TYPE_LABELS[bet.betType] || bet.betType} ·{' '}
                      {formatMoney(bet.amount)} · รอบ #{bet.roundNumber}
                    </span>
                    {bet.result && (
                      <span className="ml-2 text-xs text-gray-400">
                        ผล {bet.result}
                      </span>
                    )}
                  </div>
                  <div className="text-right">
                    <span
                      className={`rounded-full px-2 py-0.5 text-xs font-medium ${status.className}`}
                    >
                      {status.text}
                    </span>
                    {bet.payout > 0 && (
                      <p className="mt-0.5 text-xs font-bold text-brand-gold">
                        +{formatMoney(bet.payout)}
                      </p>
                    )}
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </CardContent>
    </Card>
  );
}
